'use strict';
import { tns } from "tiny-slider/src/tiny-slider";

class BlockHero {

    constructor($target) {

        // Private properties
        $target;

        let name = "HELLO";

        function init() {
            initHeroSlider();
            setupScrollBehavior();
        }

        function initHeroSlider() {
            var slider = tns({
                container: $target.find('.hero_wrapper')[0],
                items: 1,
                slideBy: 'page',
                autoplay: true,
                speed: 2000,
                controls: false,
                nav: false,
                autoplayButtonOutput: false,
            });
        }

        function setupScrollBehavior() {
            const hurrytimer = document.querySelector('.hurrytimer-campaign');
            const pageTemplate = document.querySelector('.page-template');

            if (!hurrytimer || !pageTemplate) return;

            let initialTop = getInitialTop(); // Dynamically calculate initial `top`
            let lastScrollY = window.scrollY; // Track the last known scroll position

            function getInitialTop() {
                return parseInt(getComputedStyle(hurrytimer).top, 10);
            }

            const updatePosition = () => {
                const pageTop = pageTemplate.getBoundingClientRect().top;

                if (pageTop < 0) {
                    // Move with the page but cap at top 0
                    const distance = Math.min(-pageTop, initialTop);
                    hurrytimer.style.transform = `translateY(${-distance}px)`;
                } else {
                    // Reset to the original position
                    hurrytimer.style.transform = `translateY(0)`;
                }
            };

            const handleResize = () => {
                // Update `initialTop` when the screen size changes
                initialTop = getInitialTop();
                updatePosition();
            };

            const handleScroll = () => {
                // Call update position on scroll
                updatePosition();
                lastScrollY = window.scrollY; // Keep track of the last scroll position
            };

            // Attach event listeners
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleResize);

            // Initial setup
            updatePosition();
        }

        init();

        return {

            // Public properties
            name: name,

            publicBlockHero: function (string) {
                // $target.append("HELLO!"+string);
                // console.log(name)
                // console.log(string)
                // console.log($target)
            }

        };

    }

}

export default BlockHero;
